export const sortByDate = (a: string, b: string, ascending = false): number => {
  const firstDate = new Date(a).getTime();
  const secondDate = new Date(b).getTime();

  return ascending ? secondDate - firstDate : firstDate - secondDate;
};
